import script from "./StructuralToolbox.vue?vue&type=script&setup=true&lang=js"
export * from "./StructuralToolbox.vue?vue&type=script&setup=true&lang=js"

import "./StructuralToolbox.vue?vue&type=style&index=0&id=4f5c8464&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f5c8464"]])

export default __exports__